import React from "react";
import { Link } from "react-router-dom";

export const AUTH_BG = "https://images.unsplash.com/photo-1646153114001-495dfb56506d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJhbCUyMG9mZmljZSUyMGludGVyaW9yfGVufDB8fHx8MTc4NTgzNjMyN3ww&ixlib=rb-4.1.0&q=85";

export function AuthShell({ kicker, title, subtitle, asideKicker, asideTitle, children, testId = "auth-page" }) {
  return (
    <div className="min-h-[100dvh] grid lg:grid-cols-2 bg-zinc-900 lg:bg-white relative" data-testid={testId}>
      <div className="lg:hidden absolute inset-0 overflow-hidden" aria-hidden="true" data-testid={`${testId}-mobile-backdrop`}>
        <img src={AUTH_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40 scale-105" />
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-900/40 via-zinc-900/70 to-zinc-950" />
      </div>
      <div className="relative z-10 flex flex-col justify-between gap-6 p-5 pt-7 sm:p-10 lg:p-16 lg:border-r lg:border-zinc-200" style={{ paddingBottom: "max(1.25rem, env(safe-area-inset-bottom))" }}>
        <Link to="/login" className="flex items-center gap-3 shrink-0 text-white lg:text-zinc-900" data-testid={`${testId}-logo`}>
          <div className="w-10 h-10 bg-white text-zinc-900 lg:bg-zinc-900 lg:text-white grid place-items-center font-heading font-black text-lg">M</div>
          <div>
            <div className="font-heading font-bold tracking-tight leading-none">Mind Maker 369</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-white/60 lg:text-zinc-500 mt-1">Tax Ops Console</div>
          </div>
        </Link>
        <div className="lg:hidden text-white px-1" data-testid={`${testId}-mobile-hero`}>
          <div className="text-[10px] tracking-[0.2em] uppercase text-white/60 font-semibold">{kicker}</div>
          <h1 className="font-heading font-black text-3xl tracking-tight mt-2 leading-tight">{title}</h1>
          {subtitle ? <p className="text-xs text-white/70 mt-2">{subtitle}</p> : null}
        </div>
        <div className="max-w-md w-full self-center bg-white/95 backdrop-blur-md p-5 sm:p-7 shadow-2xl shadow-black/40 lg:bg-transparent lg:backdrop-blur-0 lg:p-0 lg:shadow-none" data-testid={`${testId}-card`}>
          <div className="hidden lg:block mb-6">
            <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 font-semibold">{kicker}</div>
            <h1 className="font-heading font-black text-4xl tracking-tight mt-3 text-zinc-900">{title}</h1>
            {subtitle ? <p className="text-sm text-zinc-600 mt-4 max-w-sm">{subtitle}</p> : null}
          </div>
          {children}
        </div>
        <div className="text-[11px] tracking-[0.14em] uppercase text-white/50 lg:text-zinc-400 flex flex-wrap gap-x-4 gap-y-1">
          <span>Monday – Saturday · 09:00 – 18:00 IST</span>
          <Link to="/legal/privacy" className="hover:text-white lg:hover:text-zinc-900">Privacy</Link>
          <Link to="/legal/terms" className="hover:text-white lg:hover:text-zinc-900">Terms</Link>
        </div>
      </div>
      <div className="hidden lg:block relative overflow-hidden bg-zinc-900">
        <img src={AUTH_BG} alt="Office" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="text-[10px] tracking-[0.2em] uppercase text-white/70 font-semibold">{asideKicker}</div>
          <div className="font-heading font-bold text-2xl mt-3 max-w-md leading-tight">{asideTitle}</div>
        </div>
      </div>
    </div>
  );
}
